(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumReportGroupDetailController', CompendiumReportGroupDetailController);

    CompendiumReportGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CompendiumReportGroup', 'Compendium'];

    function CompendiumReportGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, CompendiumReportGroup, Compendium) {
        var vm = this;

        vm.compendiumReportGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:compendiumReportGroupUpdate', function(event, result) {
            vm.compendiumReportGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
